// extracted by mini-css-extract-plugin
export default {"root":"src-views-debug-containers-DebugEditionView__root--jJBxO"};